import {Button, Col, Form, Row, Space, Typography} from "antd";
import React, {useState, useEffect} from "react";
import Icons from "assets/icons";
import "./CorneaExpand.scss";
import {InputFields} from "components/common";
import {
  FieldsCornea1,
  FieldsCornea2,
  fieldsCommentLeft,
  fieldsCommentRight,
} from "./CorneaExpand.config";
import FormList from "./FormList/FormList";
import {useAppSelector} from "redux/hooks";

type Props = {
  isOpen: boolean;
  setIsOpen: () => void;
  index: number;
};

const CorneaExpand: React.FC<Props> = ({isOpen, setIsOpen, index}) => {
  const objectChanDoan = useAppSelector(
    state => state.examination.objectChanDoan
  );

  const examRef = useAppSelector(state => state.examination.ref);

  useEffect(() => {
    FieldsCornea1.find(e => e.label == "Bề mặt").onChange = e => {
      handleCheck(e, 0);
    };
    FieldsCornea2.find(e => e.label == "Bề mặt").onChange = e => {
      handleCheck(e, 1);
    };
  }, [examRef, index]);
  const defaultValues = {
    "Kích thước": "Bình thường",
    "Hình dạng": "Bình thường",
    "Bề mặt": ["Bình thường"],
    "Bắt màu Fluorescein": "Bình thường",
    "Cảm giác giác mạc": "Bình thường",
    "Test Schirmer 1": null,
    "Test Schirmer 1Inside": null,
    "Test Schirmer 2": null,
    "Test Schirmer 2Inside": null,
    FormList: [
      {
        input1: "",
        input2: "",
      },
    ],
    "Ghi chú": null,
  };
  useEffect(() => {
    if (!isOpen) {
      // const fieldsValue = ref.getChanDoanValue();
      if (examRef) {
        examRef.setFieldValue(
          [`${index == 1 ? "leftJsonValue" : "rightJsonValue"}`, "CORNEA"],
          defaultValues
        );
      }
    }
    if (examRef) {
      examRef.setFieldValue(
        [
          `${index == 1 ? "leftJsonValue" : "rightJsonValue"}`,
          "CORNEA",
          "show",
        ],
        isOpen
      );
    }
  }, [isOpen, examRef]);
  useEffect(() => {
    if (objectChanDoan && examRef) {
      const show = examRef.getFieldValue([
        `${index == 1 ? "leftJsonValue" : "rightJsonValue"}`,
        "CORNEA",
        "show",
      ]);
      (objectChanDoan);
      if (Boolean(show) == true && isOpen == false) {
        setIsOpen();
      }
      if (Boolean(show) == false && isOpen == true) {
        setIsOpen();
      }
    }
  }, [objectChanDoan, examRef]);
  const handleCheck = (e, index) => {
    if (e?.slice(-1) == "Bình thường") {
      examRef.setFieldValue(
        [
          `${index == 0 ? "rightJsonValue" : "leftJsonValue"}`,
          "CORNEA",
          "Bề mặt",
        ],
        ["Bình thường"]
      );
    } else if (e?.includes("Bình thường")) {
      const valueSurface = examRef.getFieldValue([
        `${index == 0 ? "rightJsonValue" : "leftJsonValue"}`,
        "CORNEA",
        "Bề mặt",
      ]);

      const indexOfNormal = valueSurface.indexOf("Bình thường");
      if (indexOfNormal > -1) {
        // only splice array when item is found
        valueSurface.splice(indexOfNormal, 1); // 2nd parameter means remove one item only
      }
      examRef.setFieldValue(
        [
          `${index == 0 ? "rightJsonValue" : "leftJsonValue"}`,
          "CORNEA",
          "Bề mặt",
        ],
        valueSurface
      );
    }
  };
  return (
    <Space
      direction="vertical"
      className="space-common space-cornea"
      size={"middle"}
    >
      <Row justify={"start"} className="row-common">
        <Button
          type="primary"
          icon={isOpen ? <Icons.sub rev={0} /> : <Icons.add rev={0} />}
          onClick={setIsOpen}
        />
        <Typography className="title-common-healthy">GIÁC MẠC</Typography>
      </Row>

      {isOpen ? (
        <div>
          <Row gutter={[16, 8]}>
            <InputFields data={index === 0 ? FieldsCornea1 : FieldsCornea2} />
            <FormList index={index}></FormList>
            <InputFields
              data={index === 0 ? fieldsCommentRight : fieldsCommentLeft}
            />
            {/* <Col span={24}>
            <Space>
              <Button style={{ background: "#003828", color: "#FFFFFF" }}>
                Add Cornea Diagram
              </Button>
              <Button style={{ background: "#003828", color: "#FFFFFF" }}>
                Add Cornea Slit Diagram
              </Button>
            </Space>
          </Col> */}
          </Row>
        </div>
      ) : null}
    </Space>
  );
};

export default CorneaExpand;
